// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  loaders: {
    list: false,
  },
};

const userCampaigns = (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH_USER_CAMPAIGN_DATA":
      return {
        ...state,
        data: action.data,
        total: action.total,
        params: action.params,
      };
    case "TOGGLE_SEARCH_USER_CAMPAIGN_LOADER":
      return {
        ...state,
        loaders: { ...state.loaders, list: action.visiblity },
      };
    default:
      return { ...state };
  }
};
export default userCampaigns;
